<template>
  <div class="edu-home content-430">
    <div class="header-wrapper-430">
      <SearchBlock
        :search-type="theUserIdentity === 'edu' ? 'collect' : ''"
        @on-search="onSearch"
      ></SearchBlock>
      <div class="table-title-special-430" style="justify-content: end">
        <Button
          v-if="theUserIdentity != 'edu'"
          class="back"
          style="margin-right: 16px"
          type="primary"
          @click="editHandel"
        >修改考勤</Button>
        <Button class="back" type="primary" @click="exportHandel">下载</Button>
      </div>
    </div>
    <div class="table">
      <Table
        ref="selection"
        border
        :columns="columns12"
        :data="data"
        :max-height="tableHeight - 40"
        :loading="tableLoading"
      >
        <template slot="classroomName" slot-scope="{ row }">
          <TablePoptip :content="row.schoolName"> </TablePoptip>
        </template>
        <template slot="schoolName" slot-scope="{ row }">
          <TablePoptip :content="row.schoolName"> </TablePoptip>
        </template>
        <template
          v-for="(item, key) in slotMap"
          :slot="item"
          slot-scope="{ row }"
        >
          <span
            v-if="getDayContent(row, item) == 'classNo'"
            style="color: #aaa"
          >当日无课</span>
          <span v-if="getDayContent(row, item) == 'signPeronAndTimeMap'">无老师打卡</span>
          <div
            v-if="
              !['classNo', 'signPeronAndTimeMap'].includes(
                getDayContent(row, item)
              )
            "
            class="teacher-sign"
          >
            <p v-for="(item, key) in getDayContent(row, item)" :key="key">
              <span class="teacher-name">{{ key }} </span><span>{{ item }}</span>
            </p>
          </div>
        </template>
      </Table>
      <div class="page-wrap">
        <Page
          :total="pageInfo.count"
          show-total
          show-elevator
          :current="pageInfo.page"
          :page-size="pageInfo.size"
          show-sizer
          :page-size-opts="pageSizeOpts"
          @on-change="handlePageChange"
          @on-page-size-change="handleSizeChange"
        ></Page>
      </div>
    </div>
    <Modal v-model="exportModal" title="导出教师考勤汇总" width="760">
      <div class="main">
        <RadioGroup v-model="exportType" style="margin-bottom: 20px">
          <Radio label="1" style="margin-right: 80px">导出当前月份</Radio>
          <Radio label="2">导出学期包含月份</Radio>
        </RadioGroup>
        <CheckboxGroup v-show="exportType == 2" v-model="yearMonths">
          <Checkbox
            v-for="item in yearMonthsList"
            :key="item"
            :label="item"
            style="margin-right: 20px"
          >{{ item }}</Checkbox>
        </CheckboxGroup>
      </div>
      <div slot="footer">
        <Button type="text" @click="handleCancel('formValidate')">取消</Button>
        <Button type="primary" @click="handleOK('formValidate')">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex';
import { filterParams, downloadReport, getDaysInMonth, getWeekText } from '@/utils/utils';
import commonApi from '@/request/common';
import EduCenterApi from '@/request/eduCenter';
import courseCenter from '@/request/courseCenter/index.js';
import { tableColumnsWidth, slot, key } from '@/assets/js/resetTableStyle';
import SearchBlock from './components/SearchBlock.vue';
import { getMonthBetween, getTodayDate } from '@/utils/moment.js';
import mixinTableHeight from '@/mixins/mixinTableHeight';
export default {
  name: 'SignTeacherCollect',
  components: {
    SearchBlock
  },
  mixins: [mixinTableHeight],
  data() {
    return {
      tableLoading: false,
      columns12: [
        slot('学校', 'schoolName', tableColumnsWidth.type6, {
          fixed: 'left'
        }),
        slot('课程班级名称', 'classroomName', tableColumnsWidth.type6, {
          fixed: 'left'
        }),
        key('课程类别', 'classTypeStr', tableColumnsWidth.type2, {
          fixed: 'left'

        })
        // key('课酬梯度', 'courseBillLevel', tableColumnsWidth.type7, {
        //   fixed: 'left'
        // })

      ],
      pageSizeOpts: [10, 20, 50, 100],
      data: [],
      pageInfo: {
        page: 1,
        count: 0,
        size: 10
      },
      termIdList: [], // 学期列表
      listParams: {
        // termId: '',
        orgId: '',
        yearMonth: '',
        teaId: ''
      },
      schoolId: '',
      exportModal: false,
      slotMap: [], //
      exportType: '1',
      yearMonthsList: [],
      yearMonths: []

    };
  },
  computed: { ...mapState(['userInfo', 'theUserIdentity']), ...mapGetters(['routeTitle']) },
  created() {

  },
  mounted() {
    if (this.theUserIdentity === 'school') {
      this.schoolId = this.userInfo.orgId;
      //   this.getschTeaTotalByope();
    }
  },
  activated() {
    this.initData();
    this.getschTeaTotalByope();
  },
  beforeRouteLeave(to, from, next) {
    this.PUSH_CACHEROUTE('SignTeacherCollect');
    next();
  },
  methods: {
    ...mapMutations(['PUSH_CACHEROUTE']),
    initData() {
      this.columns12 = [
        key('学校', 'schoolName', tableColumnsWidth.type6, {
          fixed: 'left'
        }),
        key('课程班级名称', 'classroomName', tableColumnsWidth.type5, {
          fixed: 'left'
        }),
        key('课程类别', 'classTypeStr', tableColumnsWidth.type2, {
          fixed: 'left'
        })
        // key('课酬梯度', 'courseBillLevel', tableColumnsWidth.type7, {
        //   fixed: 'left'
        // })

      ];
      const str = new Date().Format(this.listParams.yearMonth);
      const allDay = getDaysInMonth(str.substring(0, 4), str.substring(5));
      allDay.forEach((item) => {
        this.slotMap.push(item.substring(5));
        this.columns12.push(
          {
            title: item.substring(5),
            slot: item.substring(5),
            align: 'center',
            width: tableColumnsWidth.type4,
            className: 'teacher-sign-block',
            renderHeader: (h, params) => {
              var text = `${item.substring(5)}<br/> ${getWeekText(item)}`;
              return h('div', {
                domProps: {
                  innerHTML: text
                }
              });
            }
          }
        );
      });
    },
    onSearch(info) {
      console.log('info=======:', info);
      this.pageInfo.page = 1;
      this.listParams = info;
      this.initData();

      this.getschTeaTotalByope();
    },

    // 运营端请求教师考勤列表
    async getschTeaTotalByope() {
      //   this.listParams.termId == -1 ? '' : this.listParams.termId

      const obj = {
        schId: this.listParams.schoolId === -1 ? null : this.listParams.schoolId,
        yearMonth: this.listParams.yearMonth,
        yearCode: this.listParams.yearCode,
        termCode: this.listParams.termCode,
        // termId: this.listParams.termId,
        classroomName: this.listParams.classroomName,
        teacherName: this.listParams.teacherName,
        classType: this.listParams.classType,
        orgId: this.listParams.orgId,
        pageNum: this.pageInfo.page,
        pageSize: this.pageInfo.size,
        signPersonId: this.listParams.teaId
      };
      if (this.listParams.offerOrgType) {
        obj.offerOrgType = this.listParams.offerOrgType;
      }
      this.tableLoading = true;
      let resp;
      // if (this.theUserIdentity === 'admin' || this.theUserIdentity === 'edu') {
      //   resp = await EduCenterApi.getschTeaTotalByope(obj);
      // } else {
      //   resp = await EduCenterApi.getschTeaTotalBySch(obj);
      // }
      if (this.theUserIdentity === 'school') {
        resp = await EduCenterApi.getschTeaTotalBySch(obj);
      } else {
        resp = await EduCenterApi.getschTeaTotalByope(obj);
      }
      this.tableLoading = false;
      if (resp.status === 200) {
        resp.message.list.forEach(item => {
          item.classTypeStr = !item.classType ? '-' : (item.classType == 2 ? '基础托管' : '素质课');
          item.monthSignGatherVoS && item.monthSignGatherVoS.forEach(item_cld => {
            const monthKey = String(item_cld.month).length == 1 ? '0' + String(item_cld.month) : String(item_cld.month);
            const dayKey = String(item_cld.day).length == 1 ? '0' + String(item_cld.day) : String(item_cld.day);
            return item[`${monthKey}-${dayKey}`] = item_cld;
          });
        });
        this.data = resp.message.list;
        this.pageInfo.count = +resp.message.total;
      }
    },
    // 教师详情
    async getschTea() {
      const params = {
        teaId: this.listParams.teaId,
        // termId: this.listParams.termId == -1 ? '' : this.listParams.termId,
        yearCode: this.listParams.yearCode,
        termCode: this.listParams.termCode,
        orgId: this.listParams.orgId,
        pageNum: this.pageInfo.page,
        pageSize: this.pageInfo.size
      };
      this.tableLoading = true;
      const res = await this.$http.getschTea(params);
      this.tableLoading = false;
      if (res.status === 200) {
        this.data = res.message.list;
        this.pageInfo.count = +res.message.total;
      } else {
        this.$Message.error(res.message);
      }
    },
    editHandel() {
      this.$router.push({
        name: 'eduCenter_schoolAttendance_edit',
        query: {
          // termId: this.listParams.termId,
          orgId: this.listParams.orgId,
          classroomName: this.listParams.classroomName,
          teacherName: this.listParams.teacherName,
          yearMonth: this.listParams.yearMonth,
          trainingType: this.listParams.trainingType,
          orgName: this.listParams.orgName
        }
      });
    },
    //
    getDayContent(row, item) {
      if (!row[item] || !row[item]['classNo']) {
        return 'classNo';
      }
      if (!row[item]['signPeronAndTimeMap'] || JSON.stringify(row[item]['signPeronAndTimeMap']) == '{}') {
        return 'signPeronAndTimeMap';
      }
      return row[item]['signPeronAndTimeMap'];
    },
    // 导出
    async exportHandel() {
      this.yearMonths = [];
      this.exportType = '1';
      if (!this.listParams.yearCode) {
        this.$Message.error('请选择学期！');
        return false;
      }
      let termDates = [];
      if (this.listParams.sysYTBeginTime) {
        termDates = [this.listParams.sysYTBeginTime, this.listParams.sysYTEndTime];
      }
      if (termDates.length) {
        this.yearMonthsList = getMonthBetween(termDates[0], termDates[1]);
      } else {
        this.yearMonthsList = [];
      }

      this.exportModal = true;
    },
    // 分页
    handlePageChange(v) {
      this.pageInfo.page = v;
      // if (this.theUserIdentity === 'admin' || this.theUserIdentity === 'edu') {
      //   this.getschTeaTotalByope();
      // } else {
      //   this.getschTea();
      // }
      if (this.theUserIdentity === 'school') {
        this.getschTea();
      } else {
        this.getschTeaTotalByope();
      }
    },
    handleSizeChange(size) {
      this.pageInfo.size = size;
      this.pageInfo.page = 1;
      this.handlePageChange(1);
    },
    async getTimeScope() {
      const res = await courseCenter.getTimeScope({
        areaCode: this.userInfo.areaCode,
        termId: this.listParams.termId
      });
    },
    handleOK() {
      if (this.exportType == 2 && this.yearMonths.length == 0) {
        this.$Message.warning('请选择月份');
        return null;
      }
      const yearMonth = this.exportType == 1 ? this.listParams.yearMonth : this.yearMonths.join(',');
      const data = {
        schId: this.listParams.schoolId === -1 ? null : this.listParams.schoolId,
        // yearMonth: this.listParams.yearMonth,
        // termId: this.listParams.termId,
        yearCode: this.listParams.yearCode,
        termCode: this.listParams.termCode,
        classroomName: this.listParams.classroomName,
        teacherName: this.listParams.teacherName,
        // trainingType: this.listParams.trainingType,
        classType: this.listParams.classType,
        orgId: this.listParams.orgId,
        pageNum: 1,
        pageSize: 10000,
        yearMonth: yearMonth,
        offerOrgType: this.listParams.offerOrgType
      };
      const params = filterParams(data);
      let url = '';
      if (this.theUserIdentity === 'edu') {
        url = `${process.env.VUE_APP_API_COURSE_URL}/edu/sign/export/tea/gather`;
      } else {
        url = `${process.env.VUE_APP_API_COURSE_URL}/sign/export/tea/gather`;
      }
      downloadReport(url, params, this);
      this.exportModal = false;
    },
    handleCancel() {
      this.exportModal = false;
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/common';
.edu-home {
  min-height: 100%;
  .table {
    /deep/.teacher-sign-block {
      .ivu-table-cell {
        padding-left: 0;
        padding-right: 0;
      }
    }
    .teacher-sign {
      padding: 8px 0;
      font-size: 12px;
      p + p {
        margin-top: 12px;
      }
      .teacher-name {
        display: inline-block;
        margin-right: 6px;
        max-width: 180px;
        line-height: 18px;
      }
    }
  }
  .main {
    margin-top: 20px;
    .table_title {
      width: 100%;
      line-height: 50px;
      position: relative;
      .btn_wrap {
        position: absolute;
        top: 0;
        right: 10px;
        button {
          margin-right: 10px;
        }
      }
      span {
        font-size: 18px;
        font-weight: 600;
      }
    }
  }
  .list {
    border-bottom: 1px solid #eeeeee;
    margin-bottom: 24px;
  }
}
.form-require {
  /deep/.ivu-form-item-label::before {
    content: '*';
    display: inline-block;
    margin-right: 4px;
    line-height: 1;
    font-family: SimSun;
    font-size: 14px;
    color: #ed4014;
  }
}
</style>
